<template>
	<div class="box" @click="pays">
		<div class="img">
			<img :src="datas.productPic" />
		</div>
		<div class="info">
			<div class="bean">
				<!-- <image src="https://xianyihuyu.oss-cn-shenzhen.aliyuncs.com/tool/xy-help-bean.png" /> -->
				<span>{{datas.productName}}</span>
				<!-- <span>{{datas.bean}}</span>
				<span>+</span>
				<span>{{datas.bean}}</span> -->
			</div>
			<div class="price">
				<span>￥</span>{{datas.price}}
			</div>
		</div>
		<!-- <div class="tag" v-if="datas.archive"></div> -->
	</div>
</template>

<script>
export default {
	data() {
		return {
			placeholder : '',
			widths : '50%'
		};
	},
	computed: {
	},
	props: {
		datas : {
			type:Object,
			default:{}
		},
		idx : {
			type:Number,
			default:0
		}
	},
	methods: {
		pays(){
			let {id} = this.datas;
			let datas = this.datas;
			this.$emit('pays',datas)
		}
	}
};
</script>

<style lang="less" scoped>
	.box{
		width: 164px;
		// height: 452px;
		background: #fff;
		border-radius: 6px;
		margin-right: 15px;
		margin-bottom: 15px;
		padding: 8px;
		box-sizing: border-box;
		position: relative;
		.tag{
			width: 80px;
			height: 75px;
			position: absolute;
			left: -7px;
			top: -7px;
		}
		.img{
			width: 100%;
			height: 128px;
			overflow: hidden;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.info{
			width: 100%;
			.bean{
				width: 100%;
				height: 40px;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				color: #36373A;
				font-size: 17px;
				
				span{
					max-width: 150px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				img{
					width: 17px;
					height: 17px;
					margin-right: 5px;
				}
			}
			.price{
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				// background: linear-gradient(126deg, #FE860C 0%, #FC5F2C 100%);
				background: linear-gradient(126deg, #40A9EF 0%, #3377FF 100%);
				border-radius: 20px;
				font-size: 17px;
				color: #fff;
				span{
					font-size: 12px;
				}
			}
		}
		
		
	}
	
</style>
